import ReactGA from 'react-ga'

class AnalyticsService {
  sendEvent = (category, action, label, gtmObject) => {
    ReactGA.event({
      category,
      action,
      label
    })
    window.dataLayer.push(gtmObject)
  }
}

export default new AnalyticsService()
